// 관심사 하나: 멘션 모드(@펫이름)로 불렀는데 매칭된 룰이 없을 때, 어떤 시스템 리액션으로 fallback 할지.
//   - 멘션 게이트/키워드 매칭은 여기 없음(그건 reaction_keyword_rule + 매처 담당).
//   - fallback 풀 = 우리가 고른 시스템 리액션 slug들(일단 클라 하드코딩). 나중에 태그/SSOT로 승격 가능.
//   - 반환: reactionId | null (이벤트마다 랜덤).

// 시스템 리액션 slug. reaction.bySlug로 id 해석 → 존재하는 것만 후보.
const FALLBACK_SLUGS = ["introduce-type1", "introduce-type2", "comeon-cute"];

export function pickFallbackReactionId(reactionBySlug = {}) {
  const ids = FALLBACK_SLUGS.map((s) => reactionBySlug[s] && reactionBySlug[s].id).filter(Boolean);
  if (!ids.length) return null;
  return ids[Math.floor(Math.random() * ids.length)];
}
